module.exports = __webpack_public_path__ + "static/img/thumb_7.302e3d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_7.jpg
// module id = LrKa
// module chunks = 0